export interface Representative {
  id: number;
  responsibilityType: string;
  specialResponsibilitySummary: string;
}

export const RESPONSIBILITY: any = [
    {
        label: 'Poder general',
        value: 'RESPONSIBILITY_GENERAL'
    },
    {
        label: 'Poder especial',
        value: 'RESPONSIBILITY_ESPECIAL'
    },
];